import { createActionGroup, emptyProps } from '@ngrx/store';

export const RouterViewerActions = createActionGroup({
  source: 'RouterViewer',
  events: {
    '[routerViewer] Router Request Success': emptyProps(),
    '[routerViewer] Router Navigated Success': emptyProps(),
  },
});
